import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Logo } from '@/components/common/Logo';
import { ButtonLink } from '@/components/ui/ButtonLink';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
      <Logo size="lg" />
      <p className="mt-12 text-xs font-semibold uppercase tracking-wider text-primary">404</p>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold tracking-tight text-ink">
        Page not found
      </h1>
      <p className="mt-4 max-w-md text-ink-muted">
        The page you're looking for doesn't exist or may have moved. Try heading back to the homepage
        or browsing live placements.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <ButtonLink to="/" iconRight={<ArrowRight className="h-4 w-4" />}>Back to home</ButtonLink>
        <Link to="/jobs" className="text-sm font-medium text-ink-muted hover:text-ink px-4 py-2">
          Browse jobs
        </Link>
      </div>
    </div>
  );
}
